import I18n from "i18n-js";

import translationBG from "./bg.json";
import translationEN from "./en.json";

I18n.translations = {
  bg: translationBG,
  en: translationEN,
};

const savedLocale = window.localStorage.getItem("code");
const manuallySet = window.localStorage.getItem("code_manual") === "true";

I18n.defaultLocale = "bg";
I18n.locale = savedLocale || "bg";

if (!manuallySet) {
  fetch("https://ipapi.co/json/")
    .then((res) => res.json())
    .then((data) => {
      const locale = data.country_code === "BG" ? "bg" : "en";
      window.localStorage.setItem("code", locale);
      I18n.locale = locale;
      if (locale !== savedLocale) {
        window.location.reload();
      }
    })
    .catch(() => {
      I18n.locale = savedLocale || "bg";
    });
}

export const translate = I18n.t.bind(I18n);

export const setLocale = (locale) => (I18n.locale = locale);
export const getLocale = () => I18n.currentLocale();
